import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import {deleteClient} from "../actions";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import {setPlanRestrictionsModals} from "reducers/planRestrictionsModals/actions";
import ClientsAvailable from "components/PlanRestrictionsModals/modals/ClientsAvailable";

class ClientsButtonDelete extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      deleting: false
    }
  }

  clientDelete() {
    this.setState({
      deleting: true
    });

    this.props.deleteClient({
      id: this.props.client.id
    }).then(() => this.setState({deleting: false, modal: false}));
  }

  toggleModal(){
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    const { deleting } = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()}>
      <ModalHeader toggle={() => this.toggleModal()} tag="h2"><FormattedMessage id="clientsButtonDelete.modalHeader" /></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <p><FormattedMessage id="clientsButtonDelete.modalBody" /></p>
      </ModalBody>
      <ModalFooter>
        <div className="direction-group d-flex justify-content-end">
          <div className="direction-right">
            <FormattedMessage id="_.modal.delete.confirmation">{
              (message) => <LaddaButton
                className="btn btn-danger btn-ladda mb-0 ml-3"
                loading={deleting}
                data-style={ZOOM_OUT}
                onClick={() => this.clientDelete()}
              >
                {message}
              </LaddaButton>
            }</FormattedMessage>
            <FormattedMessage id="_.button.cancel">{
              (message) =>
                <Button color="secondary" className="mb-0 ml-3" onClick={() => this.toggleModal()}>{message}</Button>
            }</FormattedMessage>
          </div>
        </div>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Button color="" className="m-0 p-0" onClick={() => this.props.plan.clients ? this.toggleModal() : this.props.setPlanRestrictionsModals(ClientsAvailable.getName())}><i className="fas fa-times"/></Button>
        {modal}
      </React.Fragment>
    )
  }
}

ClientsButtonDelete.propTypes = {
  client: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    plan: state.user.userPlan.plan
  }
}

export default connect(mapStateToProps, { deleteClient, setPlanRestrictionsModals })(ClientsButtonDelete);